import { getGridPin } from '../../constants/clusterPins/getGridPin';
import { IFeatureProperties, TFeature } from '../../types/map';
import { fromGlobalPixels, toGlobalPixels } from '../projection';

/**
 * Координата пина раскрытого кластера: пиксельное смещение слота сетки дизайна
 * применяется к центру кластера в глобальных пикселях проекции, поэтому
 * визуальный размер ромашки не зависит от зума.
 *
 * Слот берётся из getGridPin по pinsCount/pinIndex и лимиту устройства
 * (на мобвебе сетка усечена; слоты за лимитом не рисуются — null).
 */
export function getClusterPinCoordinates(
  properties: IFeatureProperties,
  zoom: number,
  maxPinsPerCluster: number,
): YMaps.TCoord | null {
  const { coordinates, pinIndex, pinsCount } = properties;
  const pin = getGridPin(pinsCount, pinIndex, maxPinsPerCluster);

  if (!pin) {
    return null;
  }

  const [offsetX, offsetY] = pin.offset;
  // ось Y глобальных пикселей растёт вниз — так же, как ось Y дизайна
  const [pixelX, pixelY] = toGlobalPixels([coordinates.lat, coordinates.lng], zoom);

  return fromGlobalPixels([pixelX + offsetX, pixelY + offsetY], zoom);
}

export function expandClusterPinFeature(feature: TFeature, zoom: number, maxPinsPerCluster: number): TFeature | null {
  const coordinates = getClusterPinCoordinates(feature.properties, zoom, maxPinsPerCluster);

  if (!coordinates) {
    return null;
  }

  // поверхностная копия: properties намеренно шарятся со сторовской фичей,
  // как и до рантайм-раскрытия (точечные обновления properties видны обеим)
  return {
    ...feature,
    geometry: { ...feature.geometry, coordinates },
  };
}
